import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
//import "@/sass/variables.scss";

Vue.use(Vuetify);

export default new Vuetify({});
